import { Form } from '@/_components';
import { FiltersContextWithAccordion, NoDataMessage } from '@/_containers';

import { filterRenderer } from './components';
import { SupportTicketsInfiniteList } from './support-tickets-infinite-list';
import { usePage } from './use-page';

import type { SupportModule } from '../shared/schemas/support-query-schema';

type SupportPageProps = {
  module: SupportModule;
  moduleId: string;
  freshdeskId: string;
  isAllListPage?: boolean;
};

export default function Page({ module, moduleId, freshdeskId, isAllListPage = false }: SupportPageProps) {
  const { form, advFilterStr, advFiltersState, handleSubmitAdvFilters, handleClearAllAdvFilters, searching } =
    usePage(isAllListPage);

  if (!freshdeskId) {
    return <NoDataMessage message="Company information not available for support tickets." className="mt-6" />;
  }

  return (
    <Form {...form} isSubmitting={false}>
      <FiltersContextWithAccordion
        title="Support"
        advFilters={advFiltersState}
        handleSubmitAdvFilters={handleSubmitAdvFilters}
        handleClearAllAdvFilters={handleClearAllAdvFilters}
        filterRenderer={filterRenderer}
      >
        <SupportTicketsInfiniteList
          module={module}
          moduleId={moduleId}
          freshdeskId={freshdeskId}
          sort="-updated_at"
          per_page={50}
          filters={advFilterStr}
          searching={searching}
          advFiltersState={advFiltersState}
          isAllListPage={isAllListPage}
        />
      </FiltersContextWithAccordion>
    </Form>
  );
}
